import React from "react";
import Image from "@components/Image";
import Link from "@components/Link";
import Button from "@components/Button";
import styles from "./Card.module.scss";
import cx from "classnames";
import _ from "lodash";
import { useRouteContext } from "@providers/RouteProvider";
import { useTranslationContext } from "@providers/TranslationProvider";
import { useBookingContext } from "@providers/BookingProvider";
import { usePageContext } from "@providers/PageProvider";

const View = ({ mode = "", ...data }: any) => {
  const { router } = useRouteContext();
  const { i18n } = useTranslationContext();
  const { booking } = useBookingContext();
  const { hotel } = usePageContext();
  const isLight = mode === "light";
  const handler = {
    to: (data: any) => {
      router.push("offer-detail", data);
    },
    book: (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      booking.open({ hotel });
    },
  };
  return (
    <Link href={router.toUrl("offer-detail", data)}>
      <div className={cx(styles.item, styles[mode])}>
        <Image
          animated={true}
          speed={-1}
          wrapperProps={{ className: cx(styles.image) }}
          src={data?.image?.src}
          alt={data?.image?.alt}
          scale={1.01}
          layout="fill"
          objectFit="cover"
        />
        <div className={cx("text-ellipsis-2", styles.title)}>{data.title}</div>
        <div className={cx("text-ellipsis-3 flex-1", styles.content)}>
          {data?.description}
        </div>

        <div className={cx(styles.footer)}>
          <div className={cx(styles.validTime)}>{data?.expiryDate}</div>
          <div className={cx(styles.btnGroup)}>
            {!!isLight ? (
              <Button className={styles.discoverMoreBtn} type="text" dark>
                {i18n.t("Button.discoverMore")}
              </Button>
            ) : (
              <Button className={styles.discoverMoreBtn} type="text">
                {i18n.t("Button.discoverMore")}
              </Button>
            )}

            {!!isLight ? (
              <Button
                className={cx(styles.reserveBtn)}
                dark
                onClick={handler.book}
              >
                {i18n.t("Button.reserve")}
              </Button>
            ) : (
              <Button className={cx(styles.reserveBtn)} onClick={handler.book}>
                {i18n.t("Button.reserve")}
              </Button>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};
export default View;
